import React, { useState, useEffect } from 'react';
import { Camera, Save, Upload, Mail, Phone, Globe, MapPin, User, Landmark, ShieldCheck, FileCheck2, X } from 'lucide-react';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import '../../../css/custom-scrollbar.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import { Base_Url, userdata, updateprofile, Url_For_View_Document } from '../../../config/config';
import { useNavigate } from 'react-router-dom';

const UserProfileEdit = () => {
    const [hasExistingAccount, setHasExistingAccount] = useState(false);
    const [originalAccountNo, setOriginalAccountNo] = useState('');
    const [hasExistingAccountHolder, setHasExistingAccountHolder] = useState(false);
    const [originalAccountHolder, setOriginalAccountHolder] = useState('');
    const [hasExistingBankName, setHasExistingBankName] = useState(false);
    const [originalBankName, setOriginalBankName] = useState('');
    const [hasExistingIfscCode, setHasExistingIfscCode] = useState(false);
    const [originalIfscCode, setOriginalIfscCode] = useState('');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [cancelCheckFile, setCancelCheckFile] = useState(null);
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const [isLoading, isSetLoading] = useState(false);
    const navigate = useNavigate();

    const [profileImagePreview, setProfileImagePreview] = useState(null);
    const [selectedProfileImage, setSelectedProfileImage] = useState(null);

    const [userData, setUserData] = useState({
        id: cusid,
        company_name: "test",
        name: '',
        bio: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        account_holder: '',
        bank_name: '',
        account_no: '',
        ifsc_code: ''
    });

    const handleCancelCheckUpload = (event) => {
        const file = event.target.files[0];
        setCancelCheckFile(file);
    };

    const handleProfileImage = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setSelectedProfileImage(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleCancelCheckRemove = () => {
        setCancelCheckFile(null);
    };

    const generateInitialsAvatar = (name) => {
        if (!name) return null;
        const initials = name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();
        return (
            <div
                className="rounded-full flex items-center justify-center bg-gray-800 dark:bg-white text-white dark:text-gray-800 font-bold w-full h-full text-3xl"
            >
                {initials}
            </div>
        );
    };

    useEffect(() => {
        fetchUserData();
    }, [cusid, token]);

    const fetchUserData = async () => {
        const url = Base_Url + userdata;
        if (cusid) {
            try {
                const response = await fetch(url + "/" + cusid, {
                    method: 'GET',
                    headers: {
                        'token': token,
                        'cus_id': cusid,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();
                if (result.status === "SUCCESS") {
                    const { data } = result;
                    if (data.account_no) {
                        setHasExistingAccount(true);
                        setOriginalAccountNo(data.account_no);
                    }
                    if (data.account_holder_name) {
                        setHasExistingAccountHolder(true);
                        setOriginalAccountHolder(data.account_holder_name);
                    }
                    if (data.bank_name) {
                        setHasExistingBankName(true);
                        setOriginalBankName(data.bank_name);
                    }
                    if (data.ifsc_code) {
                        setHasExistingIfscCode(true);
                        setOriginalIfscCode(data.ifsc_code);
                    }

                    setUserData({
                        id: cusid,
                        name: data.name || '',
                        company_name: data.company_name || '',
                        bio: data.bio,
                        email: data.email || '',
                        phone: data.phone || '',
                        website: data.website || '',
                        address: data.address || '',
                        account_holder: data.account_holder_name,
                        bank_name: data.bank_name,
                        account_no: data.account_no || '',
                        ifsc_code: data.ifsc_code
                    });
                    if (data.profile_image) {
                        const profileWithUrl = Url_For_View_Document + data.profile_image
                        setProfileImagePreview(profileWithUrl);
                    }
                    else {
                        setProfileImagePreview(data.profile_image);
                    }
                } else {
                    toast.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Something went wrong. Please try again.');
            }
        }
    };

    const handleSubmit = async () => {
        const formData = new FormData();
        if (hasExistingAccount) {
            formData.append('account_no', originalAccountNo);
        } else {
            formData.append('account_no', userData.account_no);
        }

        if (hasExistingAccountHolder) {
            formData.append('account_holder', originalAccountHolder);
        } else {
            formData.append('account_holder', userData.account_holder);
        }

        if (hasExistingBankName) {
            formData.append('bank_name', originalBankName);
        } else {
            formData.append('bank_name', userData.bank_name);
        }

        if (hasExistingIfscCode) {
            formData.append('ifsc_code', originalIfscCode);
        } else {
            formData.append('ifsc_code', userData.ifsc_code);
        }

        for (const key in userData) {
            if (!['account_no', 'account_holder', 'bank_name', 'ifsc_code'].includes(key)) {
                formData.append(key, userData[key]);
            }
        }

        if (selectedProfileImage) {
            formData.append('profile_image', selectedProfileImage);
        }

        if (cancelCheckFile) {
            formData.append('cancel_check', cancelCheckFile);
        }

        try {
            isSetLoading(true);
            const response = await axios.post(`${Base_Url}${updateprofile}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cusid,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                isSetLoading(false);
                setTimeout(() => {
                    navigate("/dashboard");
                }, 1000)
            } else {
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.profile_image);
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.account_no);
                toast.error(response.data.message.address);
                toast.error(response.data.message.website);
                toast.error(response.data.message.cancel_check);
                isSetLoading(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Something went wrong. Please try again.');
            isSetLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === 'phone') {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(value)) {
                return;
            }
        }
        if (
            (id === 'account_no' && hasExistingAccount) ||
            (id === 'account_holder' && hasExistingAccountHolder) ||
            (id === 'bank_name' && hasExistingBankName) ||
            (id === 'ifsc_code' && hasExistingIfscCode)
        ) {
            return;
        }
        setUserData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const fieldBase = "w-full px-2.5 py-1.5 text-[10px] rounded-lg border transition-all duration-150 outline-none";
    const fieldActive = "bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700 text-gray-800 dark:text-white focus:border-gray-400 focus:ring-1 focus:ring-gray-400 dark:focus:border-gray-500 dark:focus:ring-gray-500";
    const fieldLocked = "bg-gray-100 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed";

    return (
        <div className={`h-screen w-full flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
            <div className="z-10 shrink-0">
                <NavBar />
            </div>

            <div className="flex flex-1 min-h-0 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}

                <div className="flex-1 min-w-0 min-h-0 bg-gray-200 dark:bg-black flex flex-col p-3 md:p-4">
                    <div className="flex-1 min-h-0 flex flex-col bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden">

                        {/* Header */}
                        <div className="shrink-0 flex items-center justify-between px-4 py-2.5 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
                            <div className="flex items-center gap-2">
                                <span className="w-1 h-5 bg-gray-800 dark:bg-white rounded-full"></span>
                                <div>
                                    <h1 className="text-sm font-bold text-gray-800 dark:text-white leading-none">Edit Profile</h1>
                                    <p className="text-[9px] text-gray-400 dark:text-gray-500 mt-0.5">Manage your personal & payout details</p>
                                </div>
                            </div>
                            <button
                                className="flex items-center gap-1.5 bg-gray-800 dark:bg-white hover:opacity-85 text-white dark:text-gray-800 px-4 py-1.5 rounded-lg text-[10px] font-medium transition-all"
                                onClick={handleSubmit}
                            >
                                {isLoading ? <Spinner /> : <><Save size={12} /><span>Save</span></>}
                            </button>
                        </div>

                        {/* Body */}
                        <div className="flex-1 min-h-0 flex flex-col lg:flex-row gap-3 p-3 overflow-hidden">

                            {/* Left: Avatar + Bio */}
                            <div className="lg:w-64 shrink-0 flex flex-col gap-2.5">
                                <div className="flex flex-col items-center justify-center gap-2.5 bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700 p-4">
                                    <div className="relative w-24 h-24 md:w-28 md:h-28">
                                        {profileImagePreview ? (
                                            <img
                                                src={profileImagePreview}
                                                alt="Profile"
                                                className="w-full h-full object-cover border-2 border-gray-200 dark:border-gray-700 shadow-sm rounded-full"
                                            />
                                        ) : (
                                            <div className="w-full h-full border-2 border-gray-200 dark:border-gray-700 shadow-sm rounded-full overflow-hidden">
                                                {generateInitialsAvatar(userData.name)}
                                            </div>
                                        )}
                                        <button
                                            onClick={() => document.getElementById("profileImageInput").click()}
                                            className="absolute bottom-0 right-0 bg-gray-800 dark:bg-white hover:opacity-85 text-white dark:text-gray-800 p-1.5 rounded-full shadow-sm transition-transform duration-200 hover:scale-105"
                                        >
                                            <Camera size={12} />
                                        </button>
                                        <input
                                            type="file"
                                            id="profileImageInput"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            style={{ display: 'none' }}
                                            onChange={handleProfileImage}
                                        />
                                    </div>
                                    <div className="text-center">
                                        <p className="text-[11px] font-semibold text-gray-800 dark:text-white truncate max-w-[10rem]">{userData.name || 'Your Name'}</p>
                                        <p className="text-[9px] text-gray-400 dark:text-gray-500 truncate max-w-[10rem]">{userData.email || 'your@email.com'}</p>
                                    </div>
                                    <div className="w-full pt-1.5 border-t border-gray-200 dark:border-gray-700 flex items-center justify-center gap-1 text-[9px] text-gray-400 dark:text-gray-500">
                                        <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                                        Auto-saved on submit
                                    </div>
                                </div>

                                <div className="bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700 p-2.5 flex flex-col gap-1 flex-1 min-h-0">
                                    <label htmlFor="bio" className="text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Bio</label>
                                    <textarea
                                        id="bio"
                                        placeholder="Tell us about yourself..."
                                        value={userData.bio}
                                        onChange={handleInputChange}
                                        className={`${fieldBase} ${fieldActive} resize-none flex-1`}
                                        rows="3"
                                    ></textarea>
                                </div>
                            </div>

                            {/* Right: fields */}
                            <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar pr-1">
                                <div className="flex flex-col gap-2.5">

                                    {/* Public info */}
                                    <div className="bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                        <div className="flex items-center gap-1.5 mb-2">
                                            <User size={12} className="text-gray-500 dark:text-gray-400" />
                                            <h2 className="text-[9px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">Public Information</h2>
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                            <div>
                                                <label htmlFor="name" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">Full Name *</label>
                                                <input
                                                    id="name"
                                                    type="text"
                                                    placeholder="Enter your full name"
                                                    value={userData.name}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive}`}
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor="username" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">Username</label>
                                                <input
                                                    id="username"
                                                    type="text"
                                                    placeholder="Choose a username"
                                                    value={userData.company_name}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive}`}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Private info */}
                                    <div className="bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                        <div className="flex items-center gap-1.5 mb-2">
                                            <ShieldCheck size={12} className="text-gray-500 dark:text-gray-400" />
                                            <h2 className="text-[9px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">Private Information</h2>
                                        </div>
                                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                                            <div>
                                                <label htmlFor="email" className="flex items-center gap-1 text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    <Mail size={10} /> Email
                                                </label>
                                                <input id="email" type="email" disabled value={userData.email} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="phone" className="flex items-center gap-1 text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    <Phone size={10} /> Phone
                                                </label>
                                                <input id="phone" type="tel" disabled value={userData.phone} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="website" className="flex items-center gap-1 text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    <Globe size={10} /> Website
                                                </label>
                                                <input id="website" type="url" placeholder="https://..." value={userData.website} onChange={handleInputChange} className={`${fieldBase} ${fieldActive}`} />
                                            </div>
                                            <div>
                                                <label htmlFor="UserId" className="flex items-center gap-1 text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    User ID
                                                </label>
                                                <input id="UserId" type="text" disabled value={userData.id} className={`${fieldBase} ${fieldLocked}`} />
                                            </div>
                                            <div className="col-span-2 lg:col-span-4">
                                                <label htmlFor="address" className="flex items-center gap-1 text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    <MapPin size={10} /> Address
                                                </label>
                                                <textarea
                                                    id="address"
                                                    placeholder="Enter your complete address"
                                                    value={userData.address}
                                                    onChange={handleInputChange}
                                                    className={`${fieldBase} ${fieldActive} resize-none`}
                                                    rows="2"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Bank details */}
                                    <div className="bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700 p-3">
                                        <div className="flex items-center gap-1.5 mb-2">
                                            <Landmark size={12} className="text-gray-500 dark:text-gray-400" />
                                            <h2 className="text-[9px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">Bank Details</h2>
                                        </div>

                                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                                            <div className={`${hasExistingAccountHolder ? 'opacity-70' : ''}`}>
                                                <label htmlFor="account_holder" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    Account Holder {hasExistingAccountHolder && <span className="text-[8px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1 rounded ml-0.5">Locked</span>}
                                                </label>
                                                <input
                                                    id="account_holder"
                                                    type="text"
                                                    placeholder="Account holder name"
                                                    value={hasExistingAccountHolder ? originalAccountHolder : userData.account_holder}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, ''); }}
                                                    disabled={hasExistingAccountHolder}
                                                    className={`${fieldBase} ${hasExistingAccountHolder ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`${hasExistingBankName ? 'opacity-70' : ''}`}>
                                                <label htmlFor="bank_name" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    Bank Name {hasExistingBankName && <span className="text-[8px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1 rounded ml-0.5">Locked</span>}
                                                </label>
                                                <input
                                                    id="bank_name"
                                                    type="text"
                                                    placeholder="Bank name"
                                                    value={hasExistingBankName ? originalBankName : userData.bank_name}
                                                    onChange={handleInputChange}
                                                    disabled={hasExistingBankName}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, ''); }}
                                                    className={`${fieldBase} ${hasExistingBankName ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`${hasExistingAccount ? 'opacity-70' : ''}`}>
                                                <label htmlFor="account_no" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    Account No. {hasExistingAccount && <span className="text-[8px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1 rounded ml-0.5">Locked</span>}
                                                </label>
                                                <input
                                                    id="account_no"
                                                    type="text"
                                                    placeholder="Account number"
                                                    value={hasExistingAccount ? originalAccountNo : userData.account_no}
                                                    maxLength={16}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }}
                                                    disabled={hasExistingAccount}
                                                    className={`${fieldBase} ${hasExistingAccount ? fieldLocked : fieldActive}`}
                                                />
                                            </div>

                                            <div className={`${hasExistingIfscCode ? 'opacity-70' : ''}`}>
                                                <label htmlFor="ifsc_code" className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider">
                                                    IFSC Code {hasExistingIfscCode && <span className="text-[8px] bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1 rounded ml-0.5">Locked</span>}
                                                </label>
                                                <input
                                                    id="ifsc_code"
                                                    type="text"
                                                    placeholder="IFSC code"
                                                    value={hasExistingIfscCode ? originalIfscCode : userData.ifsc_code}
                                                    onChange={handleInputChange}
                                                    disabled={hasExistingIfscCode}
                                                    className={`${fieldBase} ${hasExistingIfscCode ? fieldLocked : fieldActive}`}
                                                />
                                            </div>
                                        </div>

                                        {/* Cancel check upload */}
                                        <div className="mt-2.5 pt-2 border-t border-dashed border-gray-200 dark:border-gray-700 flex items-center gap-2 flex-wrap">
                                            <FileCheck2 size={12} className="text-gray-400 shrink-0" />
                                            <label className="text-[9px] font-medium text-gray-500 dark:text-gray-400 shrink-0 uppercase tracking-wider">
                                                Cancelled Check
                                            </label>

                                            <input
                                                type="file"
                                                id="cancel-check-upload"
                                                className="hidden"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleCancelCheckUpload}
                                            />
                                            <label
                                                htmlFor="cancel-check-upload"
                                                className="flex items-center gap-1 bg-gray-800 dark:bg-white hover:opacity-85 text-white dark:text-gray-800 px-2.5 py-1 rounded-lg cursor-pointer transition-all text-[9px] font-medium shrink-0"
                                            >
                                                <Upload size={10} />
                                                <span>Choose File</span>
                                            </label>

                                            {cancelCheckFile && (
                                                <div className="flex items-center gap-1.5 bg-gray-100 dark:bg-gray-800 pl-2 pr-1 py-1 rounded-lg text-[9px]">
                                                    <div className="w-1 h-1 bg-green-500 rounded-full shrink-0"></div>
                                                    <span className="text-gray-700 dark:text-white truncate max-w-[6rem]">{cancelCheckFile.name}</span>
                                                    <button
                                                        onClick={handleCancelCheckRemove}
                                                        className="text-red-500 hover:text-red-700 transition-colors p-0.5"
                                                        type="button"
                                                    >
                                                        <X size={12} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfileEdit;